import * as React from 'react';
import { ArticleParagraph1, UIHeading1 } from '@cian/ui-kit';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import * as styles from './styles.css';

import { trackShow } from './tracking';

export const WebToAppBanner: React.FC = () => {
  return (
    <ActionAfterViewObserver callback={trackShow} triggerOnce>
      <div className={styles['c-banner-container']}>
        <div className="cg-container-fluid-xs">
          <div className="cg-row">
            <div className={styles['content']} data-testid="WebToAppBanner">
              <div className={styles['img']} />
              <div className={styles['text']}>
                <UIHeading1 color="black_100">В приложении — проще!</UIHeading1>
                <ArticleParagraph1>Скачайте где удобно</ArticleParagraph1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ActionAfterViewObserver>
  );
};
